import * as React from 'react';
import { clsx } from 'clsx';
import styles from './styles.module.css';
import { generateDataTestId } from '../../../internal/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Обертка для элементов форм, которая позволяет указать лейбл и ошибку
 *
 * Имеет внешний отступ снизу, который можно отключить
 */
export var FormField = /*#__PURE__*/React.forwardRef(function FormField(props, ref) {
  var label = props.label,
    errorMessage = props.errorMessage,
    required = props.required,
    withoutMargin = props.withoutMargin,
    dataTestId = props.dataTestId,
    children = props.children;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: clsx(styles['field'], !!label && styles['hasLabel'], !!errorMessage && styles['hasError'], !!withoutMargin && styles['withoutMargin']),
    "data-testid": dataTestId,
    children: [label && /*#__PURE__*/_jsx("label", {
      className: clsx(styles['label'], !!required && styles['required']),
      "data-testid": generateDataTestId(dataTestId, ['label']),
      children: label
    }), children, errorMessage && /*#__PURE__*/_jsx("div", {
      className: styles['error'],
      "data-testid": generateDataTestId(dataTestId, ['error']),
      children: errorMessage
    })]
  });
});